import React from 'react';
import { View, Text, StyleSheet, ViewStyle } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Fonts, Radii, getConditionTint } from '../constants';

interface ConditionBadgeProps {
  condition: string;
  /** Smaller chip for compact rows and square cards */
  compact?: boolean;
  style?: ViewStyle;
}

/**
 * Tinted condition chip (polish round): soft tinted fill with dark text,
 * never a saturated system colour.
 */
export const ConditionBadge: React.FC<ConditionBadgeProps> = ({ condition, compact = false, style }) => {
  const { t } = useTranslation();
  const tint = getConditionTint(condition);
  return (
    <View style={[styles.chip, compact && styles.chipCompact, { backgroundColor: tint.bg }, style]}>
      <Text style={[styles.text, compact && styles.textCompact, { color: tint.fg }]} numberOfLines={1}>
        {t(`enums.condition.${condition}`, { defaultValue: condition })}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    alignSelf: 'flex-start',
    paddingHorizontal: 9,
    paddingVertical: 4,
    borderRadius: Radii.tag,
  },
  chipCompact: {
    paddingHorizontal: 7,
    paddingVertical: 3,
  },
  text: {
    fontFamily: Fonts.semiBold,
    fontSize: 11,
    lineHeight: 14,
  },
  textCompact: {
    fontSize: 10,
    lineHeight: 13,
  },
});
